import { useEffect } from 'react';

import { ProductType } from '@xing-com/crate-common-graphql-types';
import { useTracking } from '@xing-com/crate-communication-tracking';
import { usePremiumContacts } from '@xing-com/crate-upsell-hooks';
import { useProductParameter } from '@xing-com/crate-upsell-utils';
import { useExperiment } from '@xing-com/hub';

import { useCampaign } from '../hooks/use-campaign';

import { CampaignPage } from './campaign-page';
import { NewDesignPage } from './new-design-page';

const NewDesignPageFromRoute: React.FC = () => {
  const { product } = useProductParameter();

  return <NewDesignPage product={product} />;
};

const LegacyCampaignPageLoggedIn: React.FC = () => {
  const { product, campaign, loading, status } = useCampaign();
  const { premiumContactsLoading, premiumContacts } = usePremiumContacts();
  const showFacepile =
    product === ProductType.Premium && (premiumContacts?.total ?? 0) > 4;
  const { track } = useTracking();

  useEffect(() => {
    if (campaign) {
      const fixedTrackingData = {
        type: 'nwt' as const,
        application: 'wbm',
        context: product,
        sentBy: 'purchase_funnel',
        page: 'purchase_funnel/prodview',
      };

      const { currency: currencyCode } = campaign.contracts[0].price;

      const productItems = JSON.stringify(
        campaign.contracts.map((contract) => ({
          id: `${product}_${contract.id}`,
          quantity: contract.duration,
          price: contract.price.initial,
        }))
      );

      track({
        event: 'viewed_screen',
        eventSchema: 'extended' as const,
        ...fixedTrackingData,
      });
      track({
        event: 'product_viewed',
        currencyCode,
        productItems,
        eventSchema: 'ecommerce' as const,
        ...fixedTrackingData,
      });
    }
  }, [campaign, track]);

  return (
    <CampaignPage
      product={product}
      campaign={campaign}
      loading={loading}
      status={status}
      premiumContactsLoading={premiumContactsLoading}
      premiumContacts={premiumContacts}
      showFacepile={showFacepile}
    />
  );
};

export const CampaignPageLoggedIn: React.FC = () => {
  const isNewDesign = useExperiment('ABACUS-558') === 'B';

  return isNewDesign ? (
    <NewDesignPageFromRoute />
  ) : (
    <LegacyCampaignPageLoggedIn />
  );
};
